<style lang="scss">
  @use "../../../../assets/css/global.scss" as *;
  @use "../../../../assets/css/_colors.scss" as *;
  @use "../../../../assets/css/_mixins.scss" as *;
  @mixin iconContainerStyle($color, $background-color) {
    color: $color;

    &:not(.xs) {
      background-color: $background-color;
      border-radius: 0.375rem;
      position: relative;
      &.dropdownHover {
        background-color: lighten($background-color, 5%);
      }
    }
  }

  .iconContainer {
    flex-shrink: 0;

    &.allSelected {
      @include iconContainerStyle($light-blue, $primary-color);
    }

    &.approveEmails {
      @include iconContainerStyle($primary-color, $light-blue);
    }

    &.bouncedEmails {
      @include iconContainerStyle($red, $light-red);
    }

    &.calls {
      @include iconContainerStyle($purple, $light-purple);
    }

    &.campaigns {
      @include iconContainerStyle($purple, $light-purple);
    }

    &.clicks {
      @include iconContainerStyle($orange, $light-orange);
    }

    &.completeds {
      @include iconContainerStyle($text-black, $light-gray);
    }

    &.emails {
      @include iconContainerStyle($primary-color, $light-blue);
    }

    &.generalTasks {
      @include iconContainerStyle($red, $light-red);
    }

    &.interested {
      @include iconContainerStyle($pink, $light-pink);
    }

    &.liConnectionRequests {
      @include iconContainerStyle($green, $light-green);
    }

    &.liInMails {
      // @include iconContainerStyle($dark-blue, $light-blue);
      @include iconContainerStyle($dark-blue, #dfeaff);
    }

    &.meetings {
      @include iconContainerStyle($purple, $light-purple);
    }

    &.noLiveFeedActivityClicks,
    &.noLiveFeedActivityHotlist,
    &.noLiveFeedActivityOpens,
    &.noLiveFeedActivityReplies,
    &.noLiveFeedActivityVoicemails {
      @include iconContainerStyle($text-gray, $light-gray);
    }

    &.hotlist {
      @include iconContainerStyle($red, $light-red);
    }

    &.opens {
      @include iconContainerStyle($primary-color, $light-blue);
    }

    &.replies {
      @include iconContainerStyle($green, $light-green);
    }

    &.sms {
      @include iconContainerStyle($orange, $light-orange);
    }

    &.toDosComplete {
      @include iconContainerStyle(white, $primary-color);
    }

    &.voicemails {
      @include iconContainerStyle($purple, $light-purple);
    }

    &-xs {
      font-size: 1.25rem;
    }

    &-sm {
      font-size: 0.75rem;
      @include size(1.5rem);
    }

    &-md {
      font-size: 1.1rem;
      @include size(2.2rem);
    }

    &-lg {
      font-size: 1.2rem;
      @include size(3rem);
    }

    &-xlg {
      font-size: 3rem;
      @include size(4.5rem);
    }

    .fa {
      @include absolute-center;
    }
  }
</style>

<script>
  export let size = "md"; // Sizing options: xs, sm, md, lg, xlg
  export let icon;
  export let lightenOnDropdownHover = false;

  const iconMap = {
    allSelected: "fa-a",
    approveEmails: "fa-envelope-open",
    bouncedEmails: "fa-circle-exclamation",
    calls: "fa-phone purple",
    campaigns: "fa-bullhorn",
    clicks: "fa-arrow-pointer",
    completed: "fa-circle-check",
    generalTasks: "fa-clipboard-check",
    hotlist: "fa-fire",
    interested: "fa-heart",
    liConnectionRequests: "fa-user-plus",
    liInMails: "fa-brands fa-linkedin-in",
    meetings: "fa-calendar-day",
    noLiveFeedActivityClicks: "fa-arrow-pointer",
    noLiveFeedActivityHotlist: "fa-fire",
    noLiveFeedActivityOpens: "fa-envelope-open",
    noLiveFeedActivityReplies: "fa-reply",
    noLiveFeedActivityVoicemails: "fa-voicemail",
    opens: "fa-envelope-open",
    replies: "fa-reply",
    sms: "fa-comment",
    toDosComplete: "fa-check",
    voicemails: "fa-voicemail",
  };
</script>

<div
  class="iconContainer iconContainer-{size} {icon}"
  class:dropdownHover={lightenOnDropdownHover}
>
  <i class="fa {iconMap[icon]}"></i>
</div>
